import bankCoopeuch from '../../banksPNG/bankCoopeuch.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoCoopeuchIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Coopeuch',
}: IconProps) => <img src={bankCoopeuch} width={width} height={height} alt={alt} />;
